function Accordion(props) {
    return (
        <>
            <div className="accordionCont">

                {props?.data.map((accordionData) => (
                    <div className="accordion" data-aos='fade-up'>
                        <div className="head">
                        <span>
                            {accordionData.head}
                        </span>
                            <span><i className="fas"/></span>
                        </div>
                        <div className="content">
                            <p>
                                {accordionData.content}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}

export default Accordion